import { clsx } from 'clsx'
import React from 'react'
import { RegisterOptions, UseFormRegister } from 'react-hook-form'
import styles from './radio-button-group.module.css'

export type RadioOption = {
	value: string
	label: string
	append?: React.ReactNode
}

export type RadioButtonGroupProps = {
	label?: string
	labelClass?: string
	options: RadioOption[]
	className?: string
	name: string

	disabled?: boolean
	registerOptions?: RegisterOptions
	error?: string
	register?: UseFormRegister<Record<string, string>>
	displayAsRequired?: boolean
	lng?: string
}

export const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
	label,
	labelClass = '',
	options,
	className = '',
	name,
	disabled,
	registerOptions,
	error,
	register,
}) => (
	<div className={clsx(styles.container, className, disabled ? styles.disabled : '', error ? styles.error : '')}>
		{(label || registerOptions?.required) && (
			<div className={styles.labelContainer}>
				{label && <label className={clsx(styles['group-label'], 'medium')}>{label}</label>}
				{/* {(registerOptions?.required || displayAsRequired) && !disabled && (
					<span
						style={error ? { color: 'var(--color-accent--red-light)' } : undefined}
						className={styles.mandatory}
					>
						(Mandatory)
					</span>
				)} */}
			</div>
		)}

		<div className={styles['options-wrapper']}>
			<div className={styles.options}>
				{options.map((option, i) => {
					const uniqueName = `${name}-${option.value}`

					return (
						<label className={clsx(labelClass, styles.label)} key={name + i} htmlFor={uniqueName}>
							{register ? (
								<input
									type="radio"
									disabled={disabled}
									defaultValue={registerOptions?.value}
									value={option.value}
									id={uniqueName}
									{...register(name, registerOptions)}
								></input>
							) : (
								<input disabled={disabled} type="radio" placeholder={name || 'placeholder'}></input>
							)}
							<span className={styles['option']}>
								<span className={styles.circle}></span>
								<span className={styles['option-label']}>{option.label}</span>
								{option.append && <span className={styles['append']}>{option.append}</span>}
							</span>
						</label>
					)
				})}
			</div>
			{error && <div className={styles['error-message']}>{error}</div>}
		</div>
	</div>
)
